module.exports = __webpack_public_path__ + "img/product_118.34afa24.webp";